export default __webpack_public_path__ + "static/media/providers.8749a226.svg";